import type { Language } from '../types';

export function formatCount(raw: number | null | undefined, language: Language): string {
  const value = typeof raw === 'number' && Number.isFinite(raw) ? Math.max(0, raw) : 0;

  if (language === 'zh') {
    if (value >= 10000) return `${(value / 10000).toFixed(2)} 万`;
    if (value >= 1000) return `${(value / 1000).toFixed(1)}K`;
    return `${Math.floor(value)}`;
  }

  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1000) return `${(value / 1000).toFixed(1)}K`;
  return `${Math.floor(value)}`;
}

